<template>
    <div>
        <div v-if="currentTab === 'spot'">
            <component :is="tableComponent" marketType="Spot" :sortData="sortData" :marketData="marketData" />
        </div>

        <div v-else-if="currentTab === 'futures'">
            <component :is="tableComponent" marketType="Futures" :sortData="sortData" :marketData="marketData" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tableComponent: {
            type: Object,
            required: true,
        },
        webSocketUrl: {
            type: String,
            required: true,
        },
        webSocketMessageFormat: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            marketData: [],
        };
    },
    computed: {
        currentTab: {
            get() {
                return this.$store.state.tab.currentTab;
            },
            set(value) {
                this.$store.commit('tab/SET_CURRENT_TAB', value);
            }
        }
    },
    mounted() {
        this.connectWebSocket();
    },
    methods: {
        sortData(property, order) {
            this.marketData.sort((a, b) => {
                const aValue = parseFloat(a[property]);
                const bValue = parseFloat(b[property]);
                return order === "asc" ? aValue - bValue : bValue - aValue;
            });
        },
        connectWebSocket() {
            const socket = new WebSocket(this.webSocketUrl);
            socket.onopen = () => socket.send(this.webSocketMessageFormat.replace('{tab}', this.currentTab));
            socket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.market === this.currentTab) {
                    this.marketData = data.data;
                }
            };
            socket.onerror = (error) => console.error("WebSocket Error:", error);
        },
    },
    watch: {
        // computed로 연결해 두었기 때문에 watch도 기존처럼 정상적으로 동작합니다.
        currentTab() {
            this.connectWebSocket();
        },
    },
};
</script>